export default __webpack_public_path__ + "static/media/avatar_placeholder_3.dbe6b5af.jpg";